import isEmpty from 'lodash/isEmpty'

// Default the country to USA only when it is genuinely unset (an existing saved country is left
// untouched, and never rewritten). `'USA'` matches the literal `AddressInput` already defaults an
// empty country to (libs/webui/location/src/Address/AddressInput.tsx) and the `CountryList` entry
// it selects (libs/common/contract/src/address/CountryList.ts: `{ name: 'United States of America
// (the)', value: 'USA' }`). Applied ONLY to the value handed to `AddressSelectEditContent` when the
// editor is open — never to `initialValues`, which also feeds the empty-address `emptyContent`
// call-to-action (both arms' own empty checks) and must stay untouched for a genuinely absent
// address, or the call-to-action never renders.
export const withDefaultCountry = (value: any) => (isEmpty(value?.country) ? { ...value, country: 'USA' } : value)
